import { NetworkRepWithSource } from "../../../report_summary/@types";

export const getNetworkReferencesCounts = (data: Array<NetworkRepWithSource>) =>
  data.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.classification]: acc[curr.classification] + 1
    }),
    {
      malicious: 0,
      suspicious: 0,
      goodware: 0,
      unknown: 0
    } as Record<string, number>
  );

export const getNetworkReferencesCounts2 = (
  stats: Record<string, Record<string, number>>
) => {
  const { hasMoreData, total, ...rest } = stats;
  return Object.values(rest).reduce(
    (acc, curr) => {
      console.debug("curr", curr);
      return {
        malicious: acc.malicious + curr.malicious,
        suspicious: acc.suspicious + curr.suspicious,
        goodware: acc.goodware + curr.goodware,
        unknown: acc.unknown + curr.unknown
      };
    },
    {
      malicious: 0,
      suspicious: 0,
      goodware: 0,
      unknown: 0
    }
  );
};

export const getTotalMalicious = (data: Array<NetworkRepWithSource>) =>
  data.reduce(
    (acc, curr) => (curr.classification === "malicious" ? acc + 1 : acc),
    0
  );
